import mixitup from 'mixitup';

const mixitupContainer = document.querySelector('.offer-overview__wrapper');

if(mixitupContainer) {
    var mixer = mixitup(mixitupContainer, {
        load: {
            filter: ('all')
        },
        selectors: {
            target: '.offer-teaser'
        },
        animation: {
            easing: 'ease-in-out'
        }
    });
}

const inputClass = 'offer-overview-button__radio';

const hash = location.hash.substring(1);

function setFilter(input) {
    let category = input.value;
    category = category.replace('category-', '');
    const isDefaultCategory = category == 'default';
    const newHash = isDefaultCategory ? '' : `#${category}`;

    history.pushState({}, document.title, location.pathname + newHash);
}

if (hash) {
    const input = document.querySelector(`.${inputClass}[value="category-${hash}"]`);
    if (input) {
        input.checked = true;
        setFilter(input);
    }
}

document.addEventListener('change', (event) => {
    const target = event.target;
    if (target.classList.contains(inputClass)) {
        setFilter(target);
    }
});
